(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .component('photoViewerModal', {
            bindings: {
                modal: '='
            },
            templateUrl: 'app/components/photo-viewer-modal/photo-viewer-modal.tpl.html',
            controller: PhotoViewerModalController
        });

    PhotoViewerModalController.$inject = ['$document', '$scope'];

    function PhotoViewerModalController($document, $scope) {
        var ctrl = this;
        var mouseMoveHandler = null;
        var mouseUpHandler = null;

        ctrl.$onInit = function() {
            ensureModalState();
        };

        ctrl.close = function() {
            ensureModalState();
            ctrl.modal.visible = false;
            resetView();
            detachDocumentHandlers();
        };

        ctrl.zoomIn = function() {
            setScale((ctrl.modal.scale || 1) + 0.25);
        };

        ctrl.zoomOut = function() {
            setScale((ctrl.modal.scale || 1) - 0.25);
        };

        ctrl.reset = function() {
            resetView();
        };

        ctrl.rotate = function() {
            ensureModalState();
            ctrl.modal.rotation = ((ctrl.modal.rotation || 0) + 90) % 360;
        };

        ctrl.startDrag = function($event) {
            ensureModalState();

            if ((ctrl.modal.scale || 1) <= 1) {
                return;
            }

            $event.preventDefault();
            ctrl.modal.dragging = true;
            ctrl.modal.dragStartX = $event.pageX - (ctrl.modal.translateX || 0);
            ctrl.modal.dragStartY = $event.pageY - (ctrl.modal.translateY || 0);

            detachDocumentHandlers();
            mouseMoveHandler = function(event) {
                if (!ctrl.modal.dragging) {
                    return;
                }

                $scope.$applyAsync(function() {
                    ctrl.modal.translateX = event.pageX - ctrl.modal.dragStartX;
                    ctrl.modal.translateY = event.pageY - ctrl.modal.dragStartY;
                });
            };
            mouseUpHandler = function() {
                $scope.$applyAsync(function() {
                    ctrl.modal.dragging = false;
                });
                detachDocumentHandlers();
            };

            $document.on('mousemove', mouseMoveHandler);
            $document.on('mouseup', mouseUpHandler);
        };

        ctrl.onImageLoad = function() {
            resetView();
        };

        ctrl.getImageStyle = function() {
            ensureModalState();

            return {
                cursor: (ctrl.modal.scale || 1) > 1 ? (ctrl.modal.dragging ? 'grabbing' : 'grab') : 'default',
                transform: 'translate(' + (ctrl.modal.translateX || 0) + 'px, ' + (ctrl.modal.translateY || 0) + 'px) rotate(' + (ctrl.modal.rotation || 0) + 'deg) scale(' + (ctrl.modal.scale || 1) + ')',
                transformOrigin: 'center center',
                transition: ctrl.modal.dragging ? 'none' : 'transform 0.15s ease'
            };
        };

        $scope.$watch(function() {
            if (!ctrl.modal) {
                return '';
            }

            return [
                ctrl.modal.visible,
                ctrl.modal.url,
                ctrl.modal.title
            ].join('|');
        }, function(newValue, oldValue) {
            if (newValue !== oldValue && ctrl.modal && ctrl.modal.visible) {
                resetView();
            }
        });

        $scope.$on('$destroy', function() {
            detachDocumentHandlers();
        });

        function ensureModalState() {
            if (!ctrl.modal) {
                ctrl.modal = {};
            }

            if (!angular.isNumber(ctrl.modal.scale)) {
                ctrl.modal.scale = 1;
            }
            if (!angular.isNumber(ctrl.modal.translateX)) {
                ctrl.modal.translateX = 0;
            }
            if (!angular.isNumber(ctrl.modal.translateY)) {
                ctrl.modal.translateY = 0;
            }
            if (!ctrl.modal.title) {
                ctrl.modal.title = '';
            }
            if (!angular.isNumber(ctrl.modal.rotation)) {
                ctrl.modal.rotation = 0;
            }
        }

        function resetView() {
            ensureModalState();
            ctrl.modal.scale = 1;
            ctrl.modal.translateX = 0;
            ctrl.modal.translateY = 0;
            ctrl.modal.rotation = 0;
            ctrl.modal.dragging = false;
        }

        function setScale(nextScale) {
            ensureModalState();
            ctrl.modal.scale = Math.max(1, Math.min(6, nextScale));
            if (ctrl.modal.scale === 1) {
                ctrl.modal.translateX = 0;
                ctrl.modal.translateY = 0;
            }
        }

        function detachDocumentHandlers() {
            if (mouseMoveHandler) {
                $document.off('mousemove', mouseMoveHandler);
                mouseMoveHandler = null;
            }
            if (mouseUpHandler) {
                $document.off('mouseup', mouseUpHandler);
                mouseUpHandler = null;
            }
        }
    }
})();
